import { t } from '@lingui/macro';
import { BackButton } from 'components/BackButton/BackButton';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { InnerLayout } from 'components/Layout/InnerLayout/InnerLayout';
import { SideNavigation } from 'components/Navigation/SideNavigation';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { StepValidator } from 'components/Signup/StepValidator/StepValidator';
import { TradingHistory } from 'components/Signup/TradingHistory/TradingHistory';
import { TradingHistoryDE } from 'components/Signup/TradingHistory/TradingHistoryDE/TradingHistoryDE';
import { useAmplitude } from 'hooks/useAmplitude';
import { useLocale } from 'hooks/useLocale';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './tradingHistory.module.css';

export const TradingHistoryPage = () => {
  const { isDE } = useLocale();
  const applicationId = useRouterApplicationId();
  const { trackEvent } = useAmplitude();
  const { hasIndicativeOffers } = useOffers({ getOffersEnabled: true });

  const handleDocsBackTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.backCTAClicked);
  };

  const href =
    hasIndicativeOffers && !isDE
      ? PATH_NAMES.newApplicationProductOffers({ applicationId })
      : PATH_NAMES.newApplicationStep1({ applicationId });

  return (
    <BaseLayout
      pageTitle={t`New Documents | Introducer Portal`}
      contentPadding={false}
    >
      <SideNavigation />
      <StepValidator>
        <InnerLayout
          hasSidebar
          className={styles.layout}
          contentClassName={styles.mainContent}
        >
          {!isDE && <BackButton href={href} onClick={handleDocsBackTracking} />}

          {isDE ? (
            <TradingHistoryDE
              backButton={
                <BackButton href={href} onClick={handleDocsBackTracking} />
              }
            />
          ) : (
            <TradingHistory />
          )}
        </InnerLayout>
      </StepValidator>
    </BaseLayout>
  );
};
